import React, {PropTypes} from 'react';
import classNames from 'classnames';
import FieldValidationError from './FieldValidationError.jsx';

const StandardCheckboxField = ({
  autoFocus,
  input,
  disabled,
  label,
  name,
  checked,
  title,
  meta: {
    touched,
    error
  },
  onCustomChange
}) => (
  <div className={classNames(
    'form-group',
    {'has-error': touched && error}
  )}>
    {label
      ? <label title={title}>
          <input {...input}
            autoFocus={autoFocus}
            disabled={disabled}
            name={name}
            type="checkbox"
            onChange={event => {
              // redux-form overrides change event if provided to Field
              // use custom handler for other specific handling
              onCustomChange(event);
              input.onChange(event);
            }}
            checked={checked || !!input.value}/> {label}
        </label>
      : <input {...input}
          autoFocus={autoFocus}
          disabled={disabled}
          name={name}
          type="checkbox"
          onChange={event => {
              // redux-form overrides change event if provided to Field
              // use custom handler for other specific handling
              onCustomChange(event);
              input.onChange(event);
            }}
          checked={!!input.value}
        />
    }
    <FieldValidationError
      touched={touched}
      error={error}
    />
  </div>
);

StandardCheckboxField.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  name: PropTypes.string,
  checked: PropTypes.bool,
  title: PropTypes.string,
  onCustomChange: PropTypes.func
};

StandardCheckboxField.defaultProps = {
  title: '',
  onCustomChange: () => {}
};

export default StandardCheckboxField;



// WEBPACK FOOTER //
// ./src/features/shared/StandardCheckboxField.jsx